module.exports = __webpack_public_path__ + "static/img/award3_a.2a1304a.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award3_a.png
// module id = djBT
// module chunks = 7